import React from 'react';

import { Text } from '@thefarmersfront/kitchen';

import styles from './ReceiveSupplierHeader.module.scss';

/**
 * [입고관리] 공급사, 공급사코드 헤더 컴포넌트
 */
const ReceiveSupplierHeader = () => {
  return (
    <div className={styles['supplier-supplier-code-header']}>
      <Text size="large" weight="semi-bold">
        공급사
      </Text>
      <Text size="large" weight="semi-bold" color="quaternary">
        공급사코드
      </Text>
    </div>
  );
};

export default ReceiveSupplierHeader;
